import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { Router, RouterModule } from '@angular/router';
import { WhatsNewArticlesComponent } from '../_components/whats-new-articles/whats-new-articles.component';
import { HeroV2026Component } from '../_components/hero-v2026/hero-v2026.component';
import { CarouselSlide, PhotoCarouselV2026Component } from '../_components/photo-carousel-v2026/photo-carousel-v2026.component';

@Component({
    selector: 'app-resources',
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.scss'],
    imports: [WhatsNewArticlesComponent, HeroV2026Component, PhotoCarouselV2026Component, RouterModule]
})
export class ResourcesComponent implements OnInit {

  title = "Brochures and Booklets for Catholic Investors";

  boothPhotos: CarouselSlide[] = [
    {
      src: 'https://services.ifa.com/art/images/3577_1024x576_c_ifc-info-booth.webp',
      alt: 'Mary Brunson, Elizabeth and John standing behind the Investing for Catholics booth, with brochures and booklets displayed on the table',
      caption: 'Mary Brunson, Elizabeth and John at the IFC booth. Stop by at a Catholic conference and pick up a copy in person.'
    },
    {
      src: 'https://services.ifa.com/art/images/3577_1024x576_c_ifc-info-table-2026.webp',
      alt: 'Investing for Catholics brochures, booklets, business cards and pens laid out on the IFC information table',
      caption: 'The same brochures and booklets we bring to every conference, available here to download.'
    }
  ];

  constructor(private seoservice: SeoService, private meta: Meta, private router: Router) { }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
    this.meta.updateTag({name: 'keywords', content: 'catholic values investing, investing for catholics brochure, catholic investment committee booklet, catholic affiliate investment program, investing for catholics resources'});
    this.meta.updateTag({name: 'description', content: 'Download Investing for Catholics brochures and booklets for individual investors and Catholic organizations, including the IFC brochure, Do Investment Committees Pick Winners, and CAIP.'});
    this.meta.updateTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.updateTag({name: 'robots', content: 'index, follow'});

  }

}
